{
  "AUTOMATION": {
    "HEADER": "Automation",
    "DESCRIPTION": "Automation can replace and streamline existing processes that require manual effort, such as adding labels and assigning conversations to the most suitable agent. This allows the team to focus on their strengths while reducing time spent on routine tasks.",
    "LEARN_MORE": "Learn more about automation",
    "HEADER_BTN_TXT": "Add Automation Rule",
    "LOADING": "Fetching automation rules",
    "ADD": {
      "TITLE": "Add Automation Rule",
      "SUBMIT": "Create",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "FORM": {
        "NAME": {
          "LABEL": "Rule Name",
          "PLACEHOLDER": "Enter rule name",
          "ERROR": "Name is required"
        },
        "DESC": {
          "LABEL": "Description",
          "PLACEHOLDER": "Enter rule description",
          "ERROR": "Description is required"
        },
        "EVENT": {
          "LABEL": "Event",
          "PLACEHOLDER": "Please select one",
          "ERROR": "Event is required"
        },
        "PHASE": {
          "LABEL": "Faza"
        },
        "ORDER": {
          "LABEL": "Vrstni red",
          "ERROR": "Vrstni red je obvezen"
        },
        "CONDITIONS": {
          "LABEL": "Conditions"
        },
        "ACTIONS": {
          "LABEL": "Actions"
        }
      },
      "CONDITION_BUTTON_LABEL": "Add Condition",
      "ACTION_BUTTON_LABEL": "Add Action",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule added successfully",
        "ERROR_MESSAGE": "Could not able to create a automation rule, Please try again later"
      }
    },
    "LIST": {
      "TABLE_HEADER": {
        "PHASE": "Faza",
        "ORDER": "Vrstni red",
        "NAME": "Name",
        "DESCRIPTION": "Description",
        "ACTIVE": "Active",
        "CREATED_ON": "Created on",
        "WAIT": "Čakanje"
      },
      "404": "No automation rules found",
      "TABS": {
        "ALL": "Vse",
        "INSTANT": "Ob dogodku",
        "DELAYED": "Z zamikom"
      },
      "WAITS": "Čaka {duration}"
    },
    "DELETE": {
      "TITLE": "Delete Automation Rule",
      "SUBMIT": "Delete",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "CONFIRM": {
        "TITLE": "Confirm Deletion",
        "MESSAGE": "Are you sure to delete ",
        "YES": "Yes, Delete ",
        "NO": "No, Keep "
      },
      "API": {
        "SUCCESS_MESSAGE": "Automation rule deleted successfully",
        "ERROR_MESSAGE": "Could not able to delete a automation rule, Please try again later"
      }
    },
    "EDIT": {
      "TITLE": "Edit Automation Rule",
      "SUBMIT": "Update",
      "CANCEL_BUTTON_TEXT": "Cancel",
      "API": {
        "SUCCESS_MESSAGE": "Automation rule updated successfully",
        "ERROR_MESSAGE": "Could not update automation rule, Please try again later"
      }
    },
    "CLONE": {
      "TOOLTIP": "Clone",
      "API": {
        "SUCCESS_MESSAGE": "Automation cloned successfully",
        "ERROR_MESSAGE": "Could not clone automation rule, Please try again later"
      }
    },
    "FORM": {
      "EDIT": "Edit",
      "CREATE": "Create",
      "DELETE": "Delete",
      "CANCEL": "Cancel",
      "RESET_MESSAGE": "Changing event type will reset the conditions and events you have added below"
    },
    "CONDITION": {
      "DELETE_MESSAGE": "You need to have atleast one condition to save",
      "CONTACT_CUSTOM_ATTR_LABEL": "Contact Custom Attributes",
      "CONVERSATION_CUSTOM_ATTR_LABEL": "Conversation Custom Attributes"
    },
    "ACTION": {
      "DELETE_MESSAGE": "You need to have atleast one action to save",
      "TEAM_MESSAGE_INPUT_PLACEHOLDER": "Enter your message here",
      "TEAM_DROPDOWN_PLACEHOLDER": "Select teams",
      "EMAIL_INPUT_PLACEHOLDER": "Enter email",
      "URL_INPUT_PLACEHOLDER": "Enter URL",
      "SENDER_DROPDOWN_PLACEHOLDER": "Izberite e-poštni nabiralnik in naslov pošiljatelja",
      "SUBJECT_INPUT_PLACEHOLDER": "Zadeva e-pošte",
      "SMS_INBOX_DROPDOWN_PLACEHOLDER": "Izberite SMS nabiralnik, iz katerega se pošlje SMS",
      "SMS_MESSAGE_INPUT_PLACEHOLDER": "Vnesite besedilo SMS",
      "SMS_COUNTER": "{length}/{limit} znakov, {segments} SMS (preden so spremenljivke izpolnjene)"
    },
    "TOGGLE": {
      "ACTIVATION_TITLE": "Activate Automation Rule",
      "DEACTIVATION_TITLE": "Deactivate Automation Rule",
      "ACTIVATION_DESCRIPTION": "This action will activate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "DEACTIVATION_DESCRIPTION": "This action will deactivate the automation rule '{automationName}'. Are you sure you want to proceed?",
      "ACTIVATION_SUCCESFUL": "Automation Rule Activated Successfully",
      "DEACTIVATION_SUCCESFUL": "Automation Rule Deactivated Successfully",
      "ACTIVATION_ERROR": "Could not Activate Automation, Please try again later",
      "DEACTIVATION_ERROR": "Could not Deactivate Automation, Please try again later",
      "CONFIRMATION_LABEL": "Yes",
      "CANCEL_LABEL": "No"
    },
    "ATTACHMENT": {
      "UPLOAD_ERROR": "Could not upload attachment, Please try again",
      "LABEL_IDLE": "Upload Attachment",
      "LABEL_UPLOADING": "Nalaganje...",
      "LABEL_UPLOADED": "Successfully Uploaded",
      "LABEL_UPLOAD_FAILED": "Upload Failed"
    },
    "ERRORS": {
      "ATTRIBUTE_KEY_REQUIRED": "Attribute key is required",
      "FILTER_OPERATOR_REQUIRED": "Filter operator is required",
      "VALUE_REQUIRED": "Value is required",
      "VALUE_MUST_BE_BETWEEN_1_AND_998": "Value must be between 1 and 998",
      "ACTION_PARAMETERS_REQUIRED": "Action parameters are required",
      "ATLEAST_ONE_CONDITION_REQUIRED": "At least one condition is required",
      "ATLEAST_ONE_ACTION_REQUIRED": "At least one action is required"
    },
    "ACTION_NOTICES": {
      "SKIP_AUTO_PRIORITY": "To dejanje deluje samo, če je faza pravila nastavljena na »Pred označevanjem«.",
      "SKIP_AUTO_LABELING": "To dejanje deluje samo, če je faza pravila nastavljena na »Pred označevanjem«.",
      "MOVE_CONVERSATION_TO_INBOX": "V e-poštni nabiralnik je mogoče premakniti samo e-poštne pogovore in pogovore iz spletnega klepeta, spletni klepet pa le, če ima stik e-poštni naslov. Sicer pogovor ostane, kjer je, namesto tega pa se doda zasebna opomba.",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Začne nov pogovor s stikom v izbranem e-poštnem nabiralniku, mu pošlje sporočilo po e-pošti in pogovor označi kot rešen. To se zgodi vsakič, ko se pravilo zažene. Če stik nima e-poštnega naslova, se nič ne pošlje, namesto tega pa se doda zasebna opomba.",
      "SEND_SMS_IN_NEW_CONVERSATION": "Začne nov pogovor s stikom v izbranem SMS nabiralniku, mu pošlje sporočilo kot SMS in pogovor označi kot rešen. To se zgodi vsakič, ko se pravilo zažene. Sporočilo je navadno besedilo brez prilog. Če stik nima telefonske številke, se nič ne pošlje, namesto tega pa se doda zasebna opomba."
    },
    "NOTICES": {
      "AI_PROMPT": "Vsaka posamezna ocena se zaračuna.",
      "INCOMING_MESSAGES_COUNT": "To se nanaša na število dohodnih sporočil v pogovoru.",
      "OUTGOING_MESSAGES_COUNT": "To se nanaša na število odhodnih sporočil v pogovoru."
    },
    "PHASE": {
      "BEFORE_LABELING": "Pred označevanjem",
      "AFTER_LABELING": "Po označevanju"
    },
    "NONE_OPTION": "None",
    "MESSAGE_TYPE_VALUES": {
      "INCOMING": "Incoming Message",
      "OUTGOING": "Outgoing Message",
      "PRIVATE": "Private Note",
      "AI_SUMMARY": "AI Summary"
    },
    "YES_NO_VALUES": {
      "YES": "Da",
      "NO": "Ne"
    },
    "MESSAGE_SOURCE_TYPE_VALUES": {
      "FACEBOOK_MESSENGER": "Facebook Messenger",
      "INSTAGRAM_DM": "Neposredno sporočilo na Instagramu",
      "FACEBOOK_COMMENT": "Komentar na Facebooku"
    },
    "EVENTS": {
      "CONVERSATION_CREATED": "Pogovor ustvarjen",
      "CONVERSATION_UPDATED": "Pogovor posodobljen",
      "MESSAGE_CREATED": "Sporočilo ustvarjeno",
      "CONVERSATION_OPENED": "Pogovor odprt",
      "CONVERSATION_RESOLVED": "Pogovor rešen",
      "PHONE_CALL_FINISHED": "Klic končan"
    },
    "ACTIONS": {
      "ASSIGN_AGENT": "Dodeli agentu",
      "ASSIGN_TEAM": "Dodeli ekipo",
      "ADD_LABEL": "Dodaj oznako",
      "REMOVE_LABEL": "Odstrani oznako",
      "SEND_EMAIL_TO_TEAM": "Pošlji e-pošto ekipi",
      "SEND_EMAIL_TRANSCRIPT": "Pošlji prepis pogovora po e-pošti",
      "SEND_EMAIL_TRANSCRIPT_WITH_DETAILS": "Pošlji podroben prepis pogovora po e-pošti",
      "MUTE_CONVERSATION": "Utišaj pogovor",
      "SNOOZE_CONVERSATION": "Odloži pogovor",
      "RESOLVE_CONVERSATION": "Reši pogovor",
      "OPEN_CONVERSATION": "Odpri pogovor",
      "SEND_WEBHOOK_EVENT": "Pošlji dogodek webhook",
      "SEND_ATTACHMENT": "Pošlji prilogo",
      "SEND_MESSAGE": "Pošlji sporočilo",
      "ADD_NOTE": "Dodaj opombo",
      "CHANGE_PRIORITY": "Spremeni prioriteto",
      "ADD_SLA": "Dodaj SLA",
      "SKIP_AUTO_PRIORITY": "Preskoči samodejno prioriteto",
      "SKIP_AUTO_LABELING": "Preskoči samodejno označevanje",
      "AUTO_TRANSLATE": "Prevedi sporočilo",
      "AUTO_TRANSLATE_CONVERSATION": "Prevedi pogovor",
      "MOVE_CONVERSATION_TO_INBOX": "Premakni pogovor v nabiralnik",
      "SEND_MESSAGE_IN_NEW_CONVERSATION": "Pošlji sporočilo v novem pogovoru",
      "SEND_SMS_IN_NEW_CONVERSATION": "Pošlji SMS v novem pogovoru",
      "STOP_PROCESSING_RULES": "Ustavi obdelavo pravil"
    },
    "ATTRIBUTES": {
      "AI_FILTER": "Filter UI",
      "MESSAGE_TYPE": "Vrsta sporočila",
      "MESSAGE_CONTAINS": "Vsebina sporočila",
      "EMAIL": "E-pošta",
      "INBOX": "Nabiralnik",
      "CHANNEL_TYPE": "Vrsta nabiralnika",
      "CONVERSATION_LANGUAGE": "Jezik pogovora",
      "PHONE_NUMBER": "Telefonska številka",
      "STATUS": "Stanje",
      "BROWSER_LANGUAGE": "Jezik brskalnika",
      "MAIL_SUBJECT": "Zadeva e-pošte",
      "COUNTRY_NAME": "Država",
      "MARKETPLACE_COUNTRY": "Država tržnice",
      "REFERER_LINK": "Napotitvena povezava",
      "ASSIGNEE_NAME": "Prejemnik",
      "TEAM_NAME": "Ekipa",
      "PRIORITY": "Prioriteta",
      "CALL_DIRECTION": "Smer klica",
      "MISSED_CALL": "Zgrešen klic",
      "MISSED_CALL_COUNT": "Število zgrešenih klicev",
      "MESSAGE_SOURCE_TYPE": "Vrsta vira sporočila",
      "INCOMING_MESSAGE_COUNT": "Število dohodnih sporočil",
      "OUTGOING_MESSAGE_COUNT": "Število odhodnih sporočil",
      "LABEL": "Oznaka",
      "EMAIL_RECIPIENTS": "Prejemnik e-pošte",
      "EMAIL_AUTO_REPLY": "E-pošta je samodejni odgovor",
      "ATTACHMENT_EXTENSION": "Pripona priloge",
      "EXTENSION": "Klicana interna številka",
      "WORKING_HOURS": "V delovnem času",
      "AGENT_REPLIED": "Agent je odgovoril po spremembi stanja"
    },
    "WAIT": {
      "RUN_LABEL": "Zaženi dejanja",
      "INSTANT": "Ob dogodku",
      "DELAYED": "Z zamikom",
      "TRIGGER_LABEL": "Počakaj, dokler",
      "TRIGGERS": {
        "CONVERSATION_STATUS": "Pogovor ostane v stanju",
        "CUSTOMER_UNRESPONSIVE": "Stranka ne odgovori agentu",
        "AGENT_UNRESPONSIVE": "Stranka ne dobi odgovora agenta"
      },
      "STATUS_LABEL": "Stanje",
      "STATUSES": {
        "OPEN": "Odprt",
        "PENDING": "V čakanju",
        "SNOOZED": "Odložen",
        "RESOLVED": "Rešen"
      },
      "DELAY_LABEL": "Čas čakanja",
      "DELAY_ERROR": "Vnesite čas čakanja med 1 minuto in 30 dnevi",
      "DURATION": {
        "MINUTES": "{count} min",
        "HOURS": "{count} h",
        "DAYS": "{count} d"
      },
      "EXPLANATION": {
        "CONVERSATION_STATUS": "Dejanja se zaženejo, ko je pogovor v stanju {status} {duration}. Sprememba stanja pred tem jih prekliče. Oznake, delovni čas in odgovori agenta se preverijo ob koncu čakanja.",
        "CUSTOMER_UNRESPONSIVE": "Dejanja se zaženejo, ko stranka {duration} ne odgovori na sporočilo agenta. Odgovor stranke jih prekliče; novo sporočilo agenta znova zažene čakanje.",
        "AGENT_UNRESPONSIVE": "Dejanja se zaženejo, ko stranka čaka {duration} brez odgovora agenta. Odgovor agenta jih prekliče."
      }
    }
  }
}
